<template lang="pug">
#solicitar-laudos
    header
        h1 {{ $t('mensagens.laudos.solicitarLaudoBenfeitorias') }}

    .territorios
        header.mt-3.mb-3
            h2 {{ $t('mensagens.laudos.territoriosAdicionados') }}
            BaseButton(
                type='primary',
                size='small',
                icon='el-icon-plus',
                @click='changeShowModalAddTerritorios'
            )
                | {{ $t('mensagens.laudos.adicionarTerritorios') }}

        main(v-if='Object.keys(territorios).length > 0')
            CardDadosTerritorio.mb-2(
                v-for='(id, index) in Object.keys(territorios)',
                :territorio='territorios[id]',
                :index='index',
                :key='`${territorios[id].nome}_${id}`',
                :valido='cardValido[index]',
                :culturas='culturas',
                @removerTerritorio='removerTerritorio',
                @getValidacao='setValidacao',
                @getDados='setDados'
            )

        main.sem-territorios(v-else)
            a(@click='changeShowModalAddTerritorios')
                | {{ $t('mensagens.laudos.adicionarTerritorios') }}

    .acoes
        BaseButton(size='small', @click='$router.go(-1)')
            | {{ $t('mensagens.comuns.voltar') }}

        BaseButton(
            v-if='Object.keys(territorios).length > 0 && finalizar',
            size='small',
            type='primary',
            icon='el-icon-check',
            @click='solicitarLaudos'
        )
            | {{ $t('mensagens.comuns.finalizar') }}
        BaseButton(
            v-else-if='Object.keys(territorios).length > 0',
            size='small',
            type='primary',
            icon='el-icon-check',
            disabled
        )
            | {{ $t('mensagens.comuns.finalizar') }}

    el-dialog.add-territorio(
        :title="$t('mensagens.laudos.selecioneUmOuMaisTerritoriosParaSolicitacaoDeLaudos')",
        :visible.sync='showModalAddTerritorios',
        close='changeShowModalAddTerritorios'
    )
        SelecionarTerritorio(
            :selecionados='territoriosSelecionados',
            @getTerritoriosSelecionados='addTerritorios'
        )
</template>

<script>
import CardDadosTerritorio from '@/components/laudos/benfeitorias/CardDadosTerritorio';
import SelecionarTerritorio from '@/components/laudos/SelecionarTerritorio';

import TerritorioService from '@/services/TerritorioService';
import LaudosService from '@/services/LaudosService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'PageSolicitarLaudoBenfeitorias',

    components: {
        CardDadosTerritorio,
        SelecionarTerritorio,
        BaseButton
    },

    data() {
        return {
            idsTerritoriosSelecionados: [],
            territoriosSelecionados: [],
            culturas: [],
            dados: {},
            territorios: {},
            cardValido: {},
            showModalAddTerritorios: false,
            finalizar: false
        };
    },

    mounted() {
        const idsTerritoriosSelecionadosString =
            this.$route.params.idsTerritorio.split('-');
        idsTerritoriosSelecionadosString.pop();

        idsTerritoriosSelecionadosString.forEach(id =>
            this.idsTerritoriosSelecionados.push(parseInt(id))
        );
        this.getTerritorios();
        this.getCulturas();
    },

    methods: {
        getTerritorios() {
            const territorios = {
                territoriosIds: this.idsTerritoriosSelecionados
            };

            TerritorioService.solicitacaoLaudo(territorios)
                .then(({ data }) => {
                    this.territorios = {};

                    for (let i = 0; i < data.length; i += 1) {
                        let id = data[i].id;

                        this.territorios[id] = data[i];
                        this.cardValido[id] = this.cardValido[id] || false;
                        this.dados[id] = this.dados[id] || {};
                    }
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.laudos.ocorreuUmErroAoBuscarTerritorios')
                    });
                });
        },

        getCulturas() {
            LaudosService.getCulturas().then(({ data }) => {
                this.culturas = data;
            });
        },

        removerTerritorio(id) {
            this.idsTerritoriosSelecionados.splice(
                this.idsTerritoriosSelecionados.indexOf(id),
                1
            );

            delete this.territorios[id];
            delete this.cardValido[id];
            delete this.dados[id];

            this.atualizarerritoriosSelecionados();
            this.testeFinalizar();
        },

        changeShowModalAddTerritorios() {
            this.atualizarerritoriosSelecionados();
            this.showModalAddTerritorios = !this.showModalAddTerritorios;
        },

        setValidacao({ valido, id }) {
            this.cardValido[id] = valido;
            this.testeFinalizar();
        },

        testeFinalizar() {
            let finalizar = true;

            for (const id in this.cardValido) {
                if (this.cardValido[id] === false) {
                    finalizar = false;
                    break;
                }
            }

            this.finalizar = finalizar;
        },

        setDados({ dados, id }) {
            this.dados[id] = dados;
        },

        solicitarLaudos() {
            const informacaoLaudos = [];
            for (const id in this.cardValido) {
                informacaoLaudos.push(this.dados[id]);
            }

            LaudosService.cadastrarLaudos({ informacaoLaudos })
                .then(() => {
                    this.$notify.success({
                        message: this.$t('mensagens.laudos.solicitacaoRealizadaComSucesso')
                    });
                    this.$router.go(-1);
                })
                .catch(error => {
                    this.$notify.error({
                        message: error.response.data.mensagem
                    });
                });
        },

        addTerritorios(territorios) {
            this.idsTerritoriosSelecionados = territorios.map(territorio => territorio.id);
            this.getTerritorios();
            this.changeShowModalAddTerritorios();
        },

        atualizarerritoriosSelecionados() {
            this.territoriosSelecionados = [];

            for (const id in this.territorios) {
                this.territoriosSelecionados.push(this.territorios[id]);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#solicitar-laudos {
    width: calc(100vw - 115px);
    margin: 15px auto;

    .territorios {
        header {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .sem-territorios {
            display: flex;
            align-items: center;
            justify-content: center;

            height: 400px;

            a {
                text-decoration: underline;
            }

            a:hover {
                cursor: pointer;
            }
        }
    }

    .acoes {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
</style>
